import { DialogIds } from '../DialogIds.enum';
import { useActiveBillingDialog } from '../activateBillingDialog/useActiveBillingDialog';
import { useAddLandingPageSubdomainDialog } from '../addLandingPageSubdomain/useAddLandingPageSubdomain';
import { usePersonaSurveyDialog } from '../personaSurveyDialog/usePersonaSurveyDialog';
export const useAvailableDialogsConfig = (id?: DialogIds): any => {
    const mapper = {
        [DialogIds.ActivateBillingDialog]: useActiveBillingDialog().getConfig,
        [DialogIds.AddLandingPageSubdomain]: useAddLandingPageSubdomainDialog().getConfig,
        [DialogIds.PersonaSurveyDialog]: usePersonaSurveyDialog().getConfig,
    };

    return mapper[id]?.();
};
